// src/components/MailboxConnectionBanner.jsx
// The one place the dashboard says the mailbox is not connected, and the one
// control that fixes it. It is deliberately presentational: the pages that show
// it read the connection state, so the banner itself has no listener of its own.
import React from 'react';
import {
  CONNECT_MAILBOX_LABEL,
  CONNECT_MAILBOX_PATH,
  MAILBOX_NOT_CONNECTED_MESSAGE
} from '../utils/mailboxConnection';
import '../styles/MailboxConnectionBanner.css';

// A link, not a button: it goes to the existing Microsoft connect page rather
// than starting a second copy of that flow, and it works from inside a table
// row and a modal without either of them knowing about routing.
export function ConnectMailboxButton({ className = '' }) {
  return (
    <a className={`connect-mailbox-button ${className}`.trim()} href={CONNECT_MAILBOX_PATH}>
      {CONNECT_MAILBOX_LABEL}
    </a>
  );
}

export default function MailboxConnectionBanner({ connected = true, loading = true }) {
  // Silent until the user document has actually been read. A banner that
  // flashed on every page load would train her to ignore it.
  if (loading || connected) return null;

  return (
    <div className="mailbox-connection-banner" role="alert">
      <span className="mailbox-connection-banner__message">{MAILBOX_NOT_CONNECTED_MESSAGE}</span>
      <ConnectMailboxButton />
    </div>
  );
}
